export var CLIENT = 'blocktrend';
export var GA_TRACKING_ID = '';
